module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup book-edit"
  }, [(_vm.book) ? _c('h1', [_vm._v("Edit: " + _vm._s(_vm.book.name))]) : _c('h1', [_vm._v("New Book")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookToEdit.name),
      expression: "bookToEdit.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bookToEdit.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookToEdit.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-209641f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/BookEdit.vue
// module id = 280
// module chunks = 1